import { ResourceDetails } from '../common';

export enum AzureVmAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type AzureVmActionType =
  | AzureVmAction.START
  | AzureVmAction.STOP
  | AzureVmAction.RESTART;

export enum AzureVmState {
  STARTING = 'VM starting',
  RUNNING = 'VM running',
  STOPPING = 'VM stopping',
  STOPPED = 'VM stopped',
  DEALLOCATING = 'VM deallocating',
  DEALLOCATED = 'VM deallocated',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface AzureVmResourceDetails extends ResourceDetails {
  state: AzureVmState;
  size: string;
  resourceGroup: string;
}
